import React from 'react'
import Gestacao from '@resources/imgs/image-gestacao.png'
import { BsHeartFill } from 'react-icons/bs'

const HeroBanner: React.FC = () => {
  return (
    <div
      className="position-relative overflow-hidden hero-banner-bg"
      style={{
        backgroundColor: '#FA5A84',
        borderRadius: '14px',
        backgroundImage: `url(${Gestacao})`,
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div
        className="position-absolute w-100 h-100"
        style={{ top: 0, left: 0, background: 'linear-gradient(90deg, rgba(250,90,132,0.97) 55%, rgba(250,90,132,0.5) 100%)' }}
      />
      <div className="position-relative d-flex flex-column p-4 p-md-5" style={{ gap: '0.75rem' }}>
        <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
          <BsHeartFill color="#fff" size={16} />
          <span
            className="font-weight-bold text-uppercase text-white"
            style={{ fontSize: '0.7rem', letterSpacing: '0.12em', opacity: 0.85 }}
          >
            Reporte sua gestação
          </span>
        </div>
        <h2 className="text-white font-weight-bold mb-0">
          Estou grávida! E agora?
        </h2>
        <p className="text-white mb-0 text-justify" style={{ opacity: 0.92, maxWidth: '576px' }}>
          Te acompanhamos desde o início desta jornada e agora não poderia ser
          diferente! Ajude-nos a contabilizar e acompanhar o número de
          nascimento por doador.
        </p>
      </div>
    </div>
  )
}

export default HeroBanner
